import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Textarea } from 'components/Input/Textarea'
import { vNumberIntegerPositive, vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { Input } from 'components/Input/Input'
import SelectPretty from 'components/Input/SelectPretty'
import UploadAudioForPorta from './UploadAudioForPorta.container'

export default class SayPlayForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData } = this.props
    const submit = data => onSubmit(node, { extras: data })

    const voiceOptions = [
      {
        name: 'Male',
        value: 'man',
      },
      {
        name: 'Female',
        value: 'woman',
      },
    ]

    const audio = formData.audio || {}

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          The following message will be read out to the caller using text to speech.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>

        <Field
          name="loop"
          component={Input}
          type="number"
          label="Number of loops"
          // info="Set to '-1' to loop indefinitely"
        />

        {!audio.original && (
          <>
            <Field
              name="message"
              component={Textarea}
              display="standard"
              label="Message"
              validate={[vRequired]}
            />

            <Field
              name="voice"
              component={SelectPretty}
              options={voiceOptions}
              label="Voice"
              validate={[vRequired]}
            />

            <div style={{ padding: '15px 0' }} className={sText.descrip3}>
              Alternatively, upload your own audio file/hold music.
            </div>
          </>
        )}

        <Field name="audio" component={UploadAudioForPorta} />

        <div className={sLay.flex} />

        <div className={cn(sLay['layout-column'])} style={{ marginTop: '20px' }}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaSayPlay/SayPlayForm.jsx